import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { axiosAuth, setAuthorizationToken } from 'services/axios';
import { AUTH } from 'services/consts';

import AppLogger from 'utils/AppLogger';
import PATHS from 'utils/paths';

let isRefreshTokenInProgress = false;

const useRefreshToken = () => {
	const navigate = useNavigate();

	const refreshAccess = useCallback(async (token) => {
		if (isRefreshTokenInProgress) {
			const waitRefreshToken = new Promise((resolve) => {
				const interval = setInterval(() => {
					if (!isRefreshTokenInProgress) {
						clearInterval(interval);
						return resolve(localStorage.getItem('ACCESS_TOKEN') ?? false);
					}
				}, 200);
			});

			const token = await waitRefreshToken;
			return token;
		}

		isRefreshTokenInProgress = true;

		try {
			const response = await axiosAuth.post(
				AUTH.REFRESH_TOKEN,
				{
					// eslint-disable-next-line camelcase
					refresh_token:
						import.meta.env.MODE === 'development' ||
						import.meta.env.VITE_BRANCH_NAME ||
						import.meta.env.VITE_PLATFORM === 'desktop'
							? (token ?? localStorage.getItem('REFRESH_TOKEN'))
							: undefined
				},
				{
					withCredentials: true
				}
			);

			if (response.status !== 200) {
				AppLogger.error(response);
				isRefreshTokenInProgress = false;
				navigate(PATHS.LOGOUT, { replace: true });
				return false;
			}

			const { access_token: accessToken } = response.data;
			setAuthorizationToken(accessToken);
			localStorage.setItem('ACCESS_TOKEN', accessToken);

			isRefreshTokenInProgress = false;
			return accessToken;
		} catch (error) {
			AppLogger.error(error);
			isRefreshTokenInProgress = false;
			navigate(PATHS.LOGOUT, { replace: true });
			return false;
		}
	}, []);

	return refreshAccess;
};

export default useRefreshToken;
